// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsPopup__container","text":"NotificationsPopup__text"};